module.exports = __webpack_public_path__ + "img/1484142154.d5b31a30.jpg";